// The two looks of the shared form fields. `floating` (the label sits in the field and floats up)
// is the site's original style, used by careers, contact and booking-era forms. `stacked` is the
// checkout's (BUG-428, owner mock 2026-10-19): label above, white field, thin border, brand border
// on focus, red only for errors - so a long form reads as a form and not as beige on beige (BUG-427).

export type FieldVariant = 'floating' | 'stacked'

/** The input/select/textarea box. `extra` carries per-control bits (padding for a chevron, resize). */
export function controlClass(variant: FieldVariant, error: boolean, extra = ''): string {
  const tone = error ? 'border-red-400' : variant === 'stacked' ? 'border-mocha/20 focus:border-gold' : 'border-ivory-dark focus:border-gold'
  const box =
    variant === 'stacked'
      ? // 40px on desktop, 44px tap target on phone (owner 2026-10-19: tighter checkout).
        'w-full min-h-11 lg:min-h-10 rounded-md px-3 py-2 lg:py-[9px] bg-white focus:ring-2 focus:ring-gold/20'
      : 'w-full px-4 pt-5 pb-2 bg-ivory'
  return `peer ${box} border text-mocha font-body text-base lg:text-sm focus:outline-none transition-colors ${tone} ${extra}`.trim()
}

/** The label: floating inside the field, or a plain label above it (`order-first` in a flex column). */
export function labelClass(variant: FieldVariant, floating: boolean): string {
  if (variant === 'stacked') return 'order-first mb-1.5 block font-body text-xs font-medium text-mocha/80'
  return `absolute left-4 pointer-events-none font-body transition-all ${
    floating ? 'top-1.5 text-[10px] tracking-[0.15em] uppercase text-gold' : 'top-4 text-sm text-mocha/40'
  }`
}

/** The field's wrapper: a column for stacked, so the label can sit first. */
export function wrapperClass(variant: FieldVariant): string {
  return variant === 'stacked' ? 'relative flex flex-col' : 'relative'
}
